export default "__VITE_ASSET__C86Degwz__"